import "./App.scss";
import ResultSummary from "./components/ResultSummary";

function App() {
  return (
    <main className="page-container">
      <ResultSummary />
    </main>
  );
}

export default App;
